export const paginateList = (list, page, size) =>
  list.slice(page * size, (page + 1) * size);
